import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { LeanBrandTileRendererBase } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/__internal__/LeanBrandTileRendererBase";
import * as React from "react";
export var LeanBrandTileRenderer = function(props) {
    return /*#__PURE__*/ _jsx(LeanBrandTileRendererBase, _object_spread({}, props));
};
